module.exports = __webpack_public_path__ + "img/crm4.7c5684c5.png";